import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const ArrowDown = ({ strokeWidth = 1.5 }: { strokeWidth?: number }): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M19.9201 8.95L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.95'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(ArrowDown, 'arrow-down');
